import React, { useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import { FileDownloadOutlined } from '@mui/icons-material';
import { toast } from 'react-toastify';
import { downloadListExcel } from '../../utils/excelExport';
import { dateKey } from '../../utils/listData';

export default function ExportExcelButton({ loadRows, columns, sheetName, filename, disabled = false }) {
  const [busy, setBusy] = useState(false);
  const [loaded, setLoaded] = useState(0);
  const exportList = async () => {
    if (busy) return;
    setBusy(true); setLoaded(0);
    try {
      const rows = await loadRows(setLoaded);
      if (!rows.length) { toast.info('No matching records to export.'); return; }
      await downloadListExcel(rows, columns, sheetName, `${filename}-${dateKey(new Date())}`);
      toast.success(`Exported ${rows.length.toLocaleString('en-IN')} records to Excel.`);
    } catch (error) { toast.error(error.message || 'Unable to export. Please try again.'); }
    finally { setBusy(false); }
  };
  return <Button variant="outlined" startIcon={busy ? <CircularProgress size={16} color="inherit" /> : <FileDownloadOutlined />} onClick={exportList} disabled={busy || disabled} aria-label="Export filtered list to Excel">{busy ? loaded ? `Exporting ${loaded.toLocaleString('en-IN')}…` : 'Preparing export…' : 'Export Excel'}</Button>;
}
